<template>
  <div>
    <header-bar>
      スプリット
    </header-bar>
    <div class="page-block">
      <revenue-share-sub-header :sub-header="subHeader" />
      <div class="page_block__top-container">
        <split-information-link />
        <router-link
          :to="{path:'/client/revenue-share/step-1'}"
          class="c-btn">
          新規スプリット登録
        </router-link>
      </div>
      <div class="page-block__inner">
        <div class="tab-flex">
          <button
            :class="!disableButton ? 'c-btn bg-blue':'c-btn c-btn--back'"
            :disabled="!disableButton"
            @click="onFirstTabSelected">
            自分が管理者の作品
          </button>
          <button
            :class="disableButton ? 'c-btn bg-blue ml-10':'c-btn c-btn--back ml-10'"
            :disabled="disableButton"
            @click="onSecondTabSelected">
            自分がゲストの作品
          </button>
        </div>
        <revenue-share-search @setKeyWord="onClickedSearch" />
        <confirm-dialog
          name="deleteRevenueShare"
          :is-shown="confirmDialog"
          title="スプリットをキャンセルしますか？"
          :is-hover-on-default-button="true"
          @closed="onCancelClick"
          @default-clicked="onDefaultClicked"
          @cancel-clicked="onCancelClick">
          <template #body>
            キャンセルした場合、<br>
            すべてのゲストに通知されます。
          </template>
        </confirm-dialog>
        <confirm-dialog
          name="deleteRevenueSplitSuccessDialog"
          :is-shown="showDeletedRevenueSplitDialog"
          :default-button-title="false"
          :cancel-button-title="false"
          :cross-cancel-button="true"
          @closed="showDeletedRevenueSplitDialog = false">
          <template #body>
            スプリットをキャンセルしました
            <div class="mb-spacing" />
          </template>
        </confirm-dialog>
      </div>
    </div>
    <!-- separate completed section -->
    <div
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">完了</h3>
      </div>
      <div class="page-block__inner">
        <div class="my-release-list">
          <revenue-share-detail-table
            :headers="actionableTableHeader"
            :data="pagination.data"
            page-name="revenueShareIndex"
            empty-text="登録されているリリースがありません。"
            @redirectToPage="handleRedirection"
            @cancelRevenueShare="cancelRevenueShare" />
          <pagination
            :pagination="pagination"
            @on-pagination-clicked="onPaginationClicked($event)">
          </pagination>
        </div>
      </div>
    </div>
    <!-- separate pending section -->
    <div
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">承認待ち</h3>
      </div>
      <div class="page-block__inner">
        <div class="my-release-list">
          <revenue-share-detail-table
            :headers="actionableTableHeader"
            :data="pendingPagination.data"
            page-name="revenueShareIndex"
            empty-text="登録されているリリースがありません。"
            @redirectToPage="handleRedirection"
            @cancelRevenueShare="cancelRevenueShare" />
          <pagination
            :pagination="pendingPagination"
            @on-pagination-clicked="onPendingPaginationClicked($event)">
          </pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import HeaderBar from '../HeaderBar'
import {
  CMAP_RELEASE_STATUS_PUBLISHED,
  REVENUE_SHARE_COMPLETE_STATUS,
} from '../../../consts/status'
import ConfirmDialog from '../../../components/ConfirmDialog'
import Pagination from '../../../components/Pagination'
import SplitInformationLink from './SplitInformationLink'
import RevenueShareSearch from './RevenueShareSearch'
import RevenueShareSubHeader from './RevenueShareSubHeader'
import RevenueShareDetailTable from './RevenueShareDetailTable'

export default {
  name: 'RevenueShareIndex',
  components: {
    RevenueShareSubHeader,
    RevenueShareSearch,
    SplitInformationLink,
    HeaderBar,
    ConfirmDialog,
    Pagination,
    RevenueShareDetailTable,
  },
  data() {
    return {
      tabIndex: 0,
      pagination: {
        data: [],
      },
      pendingPagination: {
        data: [],
      },
      releaseStatus: CMAP_RELEASE_STATUS_PUBLISHED,
      loading: false,
      disableButton: true,
      page: 0,
      pendingRSPage: 0,
      confirmDialog: false,
      revenueShareProductDiscTrackId: null,
      status: REVENUE_SHARE_COMPLETE_STATUS,
      keyword: '',
      preKeyword: '',
      showDeletedRevenueSplitDialog: false,
      subHeader: 'スプリット一覧',
      actionableTableHeader: [
        {
          name: 'ジャケット',
          class: '',
          style: '',
          key: 'product_disc_tracks.product.coverart_filepath',
          imgStyle: 'width: 50px; height: 50px',
        },
        {
          name: 'リリースタイトル',
          class: '',
          key: 'product_disc_tracks.product.title',
        },
        {
          name: 'リリース日',
          class: '',
          key: 'product_disc_tracks.product.original_release_date',
        },
        {
          name: 'リリース種別',
          class: '',
          style: 'width: 12%',
          key: 'product.type',
          actionable: true,
        },
        {
          name: 'ステータス',
          class: '',
          key: 'isComplete',
          actionable: true,
        },
        {
          name: '',
          class: '',
          key: '',
          buttonText: ['詳細を見る', 'キャンセル'],
          buttonClass: 'btn-hover link-btn-position',
          button: true,
        }],
    }
  },
  watch: {
    keyword() {
      if (this.disableButton === false) {
        this.getRevenueShare(0, true)
        this.getRevenueShare(0, false)
      } else {
        this.getRevenueShare(0, true, 'zero')
        this.getRevenueShare(0, false, 'zero')
      }
    },
  },
  async mounted() {
    window.sessionStorage.setItem('split', JSON.stringify({}))
    await this.getRevenueShare(this.page, true)
    await this.getRevenueShare(this.pendingRSPage, false)
  },
  methods: {
    async getRevenueShare(page, revenueShareStatus = true, owner = 'one') {
      const escStr = escape(this.keyword)
      this.loading = true
      const { data } = await window.axios.get('/api/client/revenueShare/product/getRevenueShare', {
        params: {
          count: 10,
          page,
          owner,
          keyword: this.keyword,
          uniKeyword: escStr,
          rsStatus: revenueShareStatus,
        },
      })
      if (revenueShareStatus) {
        this.pagination = data
        this.pagination.data = data.data
      } else {
        this.pendingPagination = data
        this.pendingPagination.data = data.data
      }
      this.loading = false
      this.disableButton = owner !== 'one'
    },
    async cancelRevenueShare(id) {
      this.confirmDialog = true
      this.revenueShareProductDiscTrackId = id
    },
    async onDefaultClicked() {
      const response = await window.axios.delete(`/api/client/revenueShare/${this.revenueShareProductDiscTrackId}`)
      if (response.status === 204) {
        this.confirmDialog = false
        await this.getRevenueShare(0, true, 'one')
        await this.getRevenueShare(0, false, 'one')
        this.showDeletedRevenueSplitDialog = true
      }
    },
    onCancelClick() {
      this.confirmDialog = false
    },
    onPaginationClicked(page) {
      this.page = page
      if (!this.disableButton) {
        this.getRevenueShare(this.page, true)
      } else {
        this.getRevenueShare(this.page, true, 'zero')
      }
    },
    onPendingPaginationClicked(page) {
      this.pendingRSPage = page
      if (!this.disableButton) {
        this.getRevenueShare(this.pendingRSPage, false)
      } else {
        this.getRevenueShare(this.pendingRSPage, false, 'zero')
      }
    },
    onClickedSearch(event) {
      this.preKeyword = event
      this.keyword = event
    },
    handleRedirection(path) {
      this.$router.push({ path })
    },
    onFirstTabSelected() {
      this.getRevenueShare(0, true)
      this.getRevenueShare(0, false)
    },
    onSecondTabSelected() {
      this.getRevenueShare(0, true, 'zero')
      this.getRevenueShare(0, false, 'zero')
    },
  },
}
</script>

<style scoped>
.c-btn {
  padding: 10px 20px;
}

.tab-flex {
  margin: 20px 0px;
  display: flex;
  max-width: 1120px;
}

.ml-10 {
  margin-left: 10px;
}

.c-btn--back {
  background-color: #e6e6e6;
  color: #4b4b4b;
}

.bg-blue{
  background: #34458D;
}

.page_block__top-container{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 2rem;
  margin-left: 2rem;
}
.mb-spacing{
  margin-bottom: 48px;
}
</style>
